export default "__VITE_ASSET__6529018c__"